module.exports = __webpack_public_path__ + "img/member12.bc2ce7d3.png";